import axios, { AxiosError, AxiosResponse } from 'axios';
import QueryString from 'qs';

import { CHATBOT_API_VERSION } from 'constants/api.urls';
import { IRequestHeader } from 'constants/chat.interface';
import { AXIOS_API_TIMEOUT } from 'constants/global.const';

const { origin } = window.location;
const SERVER_BASE_URL = process.env.REACT_APP_BASE_API_URL || origin;

const AxiosInstance = axios.create({
  baseURL: `${SERVER_BASE_URL}${CHATBOT_API_VERSION}`,
  timeout: AXIOS_API_TIMEOUT || 15000,
});

let header = {};

AxiosInstance.interceptors.request.use(
  config => config,
  error => Promise.reject(error),
);

AxiosInstance.interceptors.response.use(
  response => response,
  (error: AxiosError) => {
    const errorEvent = new CustomEvent('networkError', { detail: error });
    window.dispatchEvent(errorEvent);
    throw error;
  },
);

export function setRequestHeaders(headerData: IRequestHeader) {
  header = { ...header, ...headerData };
  AxiosInstance.defaults.headers.common = header;
}

export const getRequest = (url: string, config: any = {}) =>
  AxiosInstance.get(url, config).then((response: AxiosResponse) => response?.data || response);

export function postRequest(url: string, payload: Record<string, any>) {
  return AxiosInstance.post(url, payload).then((response: AxiosResponse) => response.data || response);
}

export function putRequest(url: string, payload: Record<string, any>) {
  return AxiosInstance.put(url, payload).then(response => response.data || response);
}

export function deleteRequest(url: string, data: Record<string, any> = {}): Promise<any> {
  return AxiosInstance.delete(url, { data }).then((response: AxiosResponse) => response.data || response);
}

export function patchRequest(url: string, payload: Record<string, any>): Promise<any> {
  return AxiosInstance.patch(url, payload).then((response: AxiosResponse) => response.data || response);
}

export const paramsSerializer = (params: any) => QueryString.stringify(params, { arrayFormat: 'repeat' });
